import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const TextEffectsGlitchSkin = {
  ...textEffectsSharedSkin,
  'text-effects-color-1': {
    type: 'COLOR',
    defaultValue: '#FFFFFF',
  },
  'text-effects-color-2': {
    type: 'COLOR',
    defaultValue: '#FF0033',
  },
  'text-effects-color-3': {
    type: 'COLOR',
    defaultValue: '#00FF99',
  },
  'layer-angle': {
    type: 'CSSString',
    defaultValue: '0deg',
  },
  'layer-distance': {
    type: 'ALPHA',
    defaultValue: '10',
  },
  'shadow-blur': {
    type: 'NUMBER',
    defaultValue: '0',
  },
  'disable-inner-animation': {
    type: 'CSSString',
  },
  'inner-animation-speed': {
    type: 'CSSString',
    defaultValue: '12.6',
  },
} as const satisfies SiteAssetsSkinParams;

const TextEffectsGlitchSkinDefinitionMap: Record<string, SiteAssetsSkinParams> =
  {
    'wixui.skins.TextEffectsGlitch': TextEffectsGlitchSkin,
  };

export default generateSkinDefaults(TextEffectsGlitchSkinDefinitionMap);
